module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('ul', {
    staticClass: "list-box",
    staticStyle: {
      "width": "972px",
      "margin": "0 auto"
    }
  }, _vm._l((_vm.dataInfo), function(item, i) {
    return _c('li', {
      key: i,
      class: [i !== 0 && (i + 1) % 5 === 0 ? 'no-margin-right' : ''],
      on: {
        "click": function($event) {
          _vm.showTeacher(i)
        }
      }
    }, [_c('div', {
      directives: [{
        name: "lazy",
        rawName: "v-lazy:background-image",
        value: (("" + (item.uIcon == null ? _vm.defaultImage : item.uIcon))),
        expression: "`${item.uIcon == null ? defaultImage : item.uIcon}`",
        arg: "background-image"
      }],
      staticClass: "avatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "content",
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('p', [_c('span', [_vm._v(_vm._s(item.uName))])]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(item.uOrg) + "\n        ")]), _vm._v(" "), _c('p', [_vm._v("\n          " + _vm._s(item.uTitle) + "\n        ")])])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.info.cpnContent)
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFl),
      expression: "showFl"
    }],
    staticClass: "cover",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "bunce2"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFl),
      expression: "showFl"
    }],
    staticClass: "contain-box"
  }, [_c('div', [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "avatar-box",
    staticStyle: {
      "display": "inline-block",
      "vertical-align": "top",
      "border": "1px solid #dedede"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.curTeacher.uIcon == null ? _vm.defaultImage : _vm.curTeacher.uIcon,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "curteacher",
    staticStyle: {
      "display": "inline-block",
      "width": "510px",
      "font-size": "16px"
    }
  }, [_c('p', [_c('span', {
    staticStyle: {
      "margin-right": "30px",
      "font-size": "18px"
    }
  }, [_vm._v(_vm._s(_vm.curTeacher.uName))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.curTeacher.uTitle))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.curTeacher.uOrg) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "font-size": "14px",
      "height": "245px",
      "overflow": "auto",
      "line-height": "1.8em"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.curTeacher.uDesc)
    }
  })]), _vm._v(" "), _c('a', {
    staticClass: "close",
    on: {
      "click": _vm.close
    }
  }, [_c('img', {
    attrs: {
      "src": require("./close.png"),
      "alt": ""
    }
  })])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3af04d12"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/iTeacher/iTeacher.vue
// module id = 790
// module chunks = 10